import { toast as rtToast } from 'react-toastify';

export const useToast = () => {
  const toast = ({ title, description, variant }) => {
    const message = title
      ? `${title}${description ? `: ${description}` : ''}`
      : description;
    const type =
      variant === 'success'
        ? 'success'
        : variant === 'destructive'
        ? 'error'
        : variant;
    rtToast(message, { type });
  };
  return { toast };
};